module.exports = __webpack_public_path__ + "static/img/n2_8.69a70c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/n2_8.jpg
// module id = k/7+
// module chunks = 2